/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // ============================================================
  // Final Sale Popup — Intercepts add-to-cart for final sale products
  // ============================================================

  var finalSaleAccepted = false;

  /**
   * Find the add-to-cart button from a click event target.
   * Returns the button element if it has data-final-sale, otherwise null.
   */
  function getFinalSaleButton(target) {
    if (!target) return null;
    var button = target.matches('[data-add-to-cart][data-final-sale]')
      ? target
      : target.closest('[data-add-to-cart][data-final-sale]');
    return button || null;
  }

  /**
   * Find the popup element associated with a button.
   * Looks for [data-final-sale-popup] within the same product container.
   */
  function getPopupForButton(button) {
    var productContainer = button.closest('[data-product]') || button.closest('[data-section-id]');
    if (productContainer) {
      return productContainer.querySelector('[data-final-sale-popup]');
    }
    // Fallback: find any popup on the page
    return document.querySelector('[data-final-sale-popup]');
  }

  /**
   * Show the final sale popup
   */
  function showPopup(popup) {
    if (!popup) return;
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('final-sale-popup-open');
  }

  /**
   * Hide the final sale popup
   */
  function hidePopup(popup) {
    if (!popup) return;
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('final-sale-popup-open');
  }

  // --- Main click interceptor (capture phase, runs before theme handler) ---
  document.addEventListener('click', function(event) {
    var button = getFinalSaleButton(event.target);
    if (!button) return;

    // If already accepted, let the theme handler process the click
    if (finalSaleAccepted) {
      finalSaleAccepted = false;
      return;
    }

    // Block the event from reaching the theme's cartAddEvent handler
    event.preventDefault();
    event.stopImmediatePropagation();

    var popup = getPopupForButton(button);
    if (!popup) return;

    // Store reference to the button that was clicked
    popup._triggerButton = button;

    showPopup(popup);
  }, true); // <-- capture phase

  // --- Handle "Accetta" (Accept) button ---
  document.addEventListener('click', function(event) {
    var acceptBtn = event.target.matches('[data-final-sale-accept]')
      ? event.target
      : event.target.closest('[data-final-sale-accept]');

    if (!acceptBtn) return;

    var popup = acceptBtn.closest('[data-final-sale-popup]');
    if (!popup) return;

    hidePopup(popup);

    var triggerButton = popup._triggerButton;
    if (triggerButton) {
      // Set the flag so the capture handler lets it through
      finalSaleAccepted = true;
      // Re-trigger the click on the original add-to-cart button
      triggerButton.click();
    }
  });

  // --- Handle "Rinuncia" (Decline) button ---
  document.addEventListener('click', function(event) {
    var declineBtn = event.target.matches('[data-final-sale-decline]')
      ? event.target
      : event.target.closest('[data-final-sale-decline]');

    if (!declineBtn) return;

    var popup = declineBtn.closest('[data-final-sale-popup]');
    if (!popup) return;

    hidePopup(popup);
  });

  // --- Handle overlay click (close popup) ---
  document.addEventListener('click', function(event) {
    if (event.target.matches('[data-final-sale-popup-close]')) {
      var popup = event.target.closest('[data-final-sale-popup]');
      if (popup) {
        hidePopup(popup);
      }
    }
  });

  // --- Handle Escape key ---
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      var visiblePopup = document.querySelector('[data-final-sale-popup].is-visible');
      if (visiblePopup) {
        hidePopup(visiblePopup);
      }
    }
  });

})();


// ============================================================
// Welcome Discount Popup — Collects email/WhatsApp for discount
// ============================================================

(function() {
  var STORAGE_KEY = 'fb_welcome_discount_claimed';

  // --- Helpers ---
  function isAlreadyClaimed() {
    try { return localStorage.getItem(STORAGE_KEY) === 'true'; }
    catch (e) { return false; }
  }

  function markAsClaimed() {
    try { localStorage.setItem(STORAGE_KEY, 'true'); }
    catch (e) { /* silent */ }
  }

  function getPopup() {
    return document.querySelector('[data-welcome-discount-popup]');
  }

  // --- Cloudflare Turnstile (antibot) ---
  // Lo script si carica alla prima apertura del popup, non al caricamento della
  // pagina: il popup e' incluso ovunque, ma quasi nessuno lo apre. Rendering
  // esplicito, cosi' il widget nasce solo quando serve davvero.
  var TURNSTILE_SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var turnstileWidgetId = null;
  var turnstileLoading = false;
  var turnstileLastError = null;

  function turnstileSitekey() {
    var popup = getPopup();
    return popup ? (popup.getAttribute('data-turnstile-sitekey') || '') : '';
  }

  function mountTurnstile() {
    var sitekey = turnstileSitekey();
    if (!sitekey || turnstileWidgetId !== null || turnstileLoading) return;

    var popup = getPopup();
    var holder = popup && popup.querySelector('[data-wd-turnstile]');
    if (!holder) return;

    turnstileLoading = true;

    var render = function() {
      turnstileLoading = false;
      if (!window.turnstile || turnstileWidgetId !== null) return;
      try {
        turnstileWidgetId = window.turnstile.render(holder, {
          sitekey: sitekey,
          action: 'welcome-discount',
          // Niente appearance:'interaction-only'. Verificato in produzione: con
          // quel valore il widget si monta ma non emette mai il token, quindi il
          // server rifiuta ogni iscrizione. Con l'aspetto predefinito il token
          // arriva (816 char) e il riquadro Turnstile resta visibile nel form.
          'error-callback': function(code) {
            // Codici utili in diagnosi: 110200 = dominio non fra quelli
            // autorizzati sul widget in Cloudflare.
            turnstileLastError = code;
            console.warn('[welcome-discount] Turnstile error', code);
          }
        });
      } catch (e) {
        // Widget non montabile: si prosegue senza token. Il server accetta o
        // rifiuta secondo la sua configurazione, il popup non si blocca qui.
        turnstileWidgetId = null;
      }
    };

    if (window.turnstile) { render(); return; }

    if (!document.querySelector('script[data-wd-turnstile-script]')) {
      var script = document.createElement('script');
      script.src = TURNSTILE_SCRIPT;
      script.async = true;
      script.defer = true;
      script.setAttribute('data-wd-turnstile-script', '');
      script.onload = render;
      script.onerror = function() { turnstileLoading = false; };
      document.head.appendChild(script);
    } else {
      // Script gia' in volo da un'apertura precedente: si attende il global.
      var waited = 0;
      var poll = setInterval(function() {
        waited += 100;
        if (window.turnstile) { clearInterval(poll); render(); }
        else if (waited >= 5000) { clearInterval(poll); turnstileLoading = false; }
      }, 100);
    }
  }

  function turnstileToken() {
    if (!turnstileSitekey() || turnstileWidgetId === null || !window.turnstile) return '';
    try { return window.turnstile.getResponse(turnstileWidgetId) || ''; }
    catch (e) { return ''; }
  }

  function resetTurnstile() {
    if (turnstileWidgetId === null || !window.turnstile) return;
    try { window.turnstile.reset(turnstileWidgetId); } catch (e) { /* silent */ }
  }

  function showPopup() {
    var popup = getPopup();
    if (!popup) return;

    var formState    = popup.querySelector('[data-wd-form-state]');
    var successState = popup.querySelector('[data-wd-success-state]');
    var alreadyState = popup.querySelector('[data-wd-already-state]');

    if (isAlreadyClaimed()) {
      // Show "already claimed"
      if (formState)    formState.style.display    = 'none';
      if (successState) successState.style.display = 'none';
      if (alreadyState) alreadyState.style.display = '';
    } else {
      // Show form
      if (formState)    formState.style.display    = '';
      if (successState) successState.style.display = 'none';
      if (alreadyState) alreadyState.style.display = 'none';
    }

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wd-popup-open');

    if (!isAlreadyClaimed()) mountTurnstile();

    // Focus first input after animation
    setTimeout(function() {
      var firstInput = popup.querySelector('#wd-email');
      if (firstInput && !isAlreadyClaimed()) firstInput.focus();
    }, 350);
  }

  function hidePopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wd-popup-open');
  }

  // --- Open popup via custom event ---
  document.addEventListener('open-welcome-discount', function() {
    showPopup();
  });

  // --- Inject trigger into product form area ---
  function injectTrigger() {
    var template = document.getElementById('wd-trigger-template');
    if (!template) return;

    var targets = [
      '.product__submit__buttons',
      '.product__submit__holder',
      '.product-single__form .product__submit__item:last-child',
      '.product__form .product__submit__item:last-child',
      '.product-single__form',
      '.product__form'
    ];

    var anchor = null;
    for (var i = 0; i < targets.length; i++) {
      anchor = document.querySelector(targets[i]);
      if (anchor) break;
    }

    if (!anchor) return;
    if (document.querySelector('[data-wd-trigger]')) return;

    var clone = template.content.cloneNode(true);
    anchor.parentNode.insertBefore(clone, anchor.nextSibling);
  }

  // --- Trigger click → open popup ---
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-wd-trigger]');
    if (trigger) {
      showPopup();
    }
  });

  // --- Generic open trigger (footer "Iscriviti" button, etc.) ---
  document.addEventListener('click', function(event) {
    var opener = event.target.closest('[data-welcome-discount-open]');
    if (!opener) return;
    event.preventDefault();
    showPopup();
  });

  // Inject on DOMContentLoaded and also observe for dynamic loading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTrigger);
  } else {
    injectTrigger();
  }
  // Re-inject after theme sections reload (Shopify theme editor / dynamic sections)
  document.addEventListener('shopify:section:load', injectTrigger);

  // --- Close popup (overlay + close buttons) ---
  document.addEventListener('click', function(event) {
    if (event.target.matches('[data-welcome-discount-close]') ||
        event.target.closest('[data-welcome-discount-close]')) {
      hidePopup();
    }
  });

  // --- Escape key ---
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      var popup = getPopup();
      if (popup && popup.classList.contains('is-visible')) {
        hidePopup();
      }
    }
  });

  // --- Scelta del canale (email o WhatsApp, stesso 10%) ---
  document.addEventListener('change', function(event) {
    if (event.target.name !== 'wd-tier') return;

    var popup = getPopup();
    if (!popup) return;

    var tier = event.target.value;
    var whatsappField = popup.querySelector('[data-wd-whatsapp-field]');
    var options = popup.querySelectorAll('[data-wd-option]');

    // Update active class on option cards
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (opt.getAttribute('data-wd-option') === tier) {
        opt.classList.add('wd-popup__option--active');
      } else {
        opt.classList.remove('wd-popup__option--active');
      }
    }

    // Show/hide WhatsApp field
    if (whatsappField) {
      whatsappField.style.display = (tier === 'whatsapp') ? '' : 'none';
      var input = whatsappField.querySelector('input');
      if (input) {
        input.required = (tier === 'whatsapp');
        if (tier !== 'whatsapp') input.value = '';
      }
    }
  });

  // --- Form submission ---
  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-wd-form]');
    if (!form) return;

    event.preventDefault();

    var popup = getPopup();
    if (!popup) return;

    var config = window.__wdConfig || {};
    var apiUrl = popup.getAttribute('data-api-url');

    // Get elements
    var emailInput    = form.querySelector('#wd-email');
    var whatsappInput = form.querySelector('#wd-whatsapp');
    var privacyInput  = form.querySelector('#wd-privacy');
    var tierInput     = popup.querySelector('input[name="wd-tier"]:checked');
    var errorEl       = form.querySelector('[data-wd-error]');
    var submitBtn     = form.querySelector('[data-wd-submit]');
    var submitText    = form.querySelector('[data-wd-submit-text]');
    var submitLoading = form.querySelector('[data-wd-submit-loading]');

    // Get values
    var email    = emailInput ? emailInput.value.trim() : '';
    var whatsapp = whatsappInput ? whatsappInput.value.trim() : '';
    var channel  = (tierInput && tierInput.value === 'whatsapp') ? 'whatsapp' : 'email';
    var privacy  = privacyInput ? privacyInput.checked : false;

    // Reset error states
    if (errorEl) errorEl.style.display = 'none';
    var errorFields = form.querySelectorAll('.wd-error');
    for (var i = 0; i < errorFields.length; i++) {
      errorFields[i].classList.remove('wd-error');
    }

    // Validate email
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      if (emailInput) emailInput.classList.add('wd-error');
      showError(errorEl, config.errorEmailText || 'Invalid email');
      return;
    }

    // Validate WhatsApp if chosen as channel
    if (channel === 'whatsapp') {
      if (!whatsapp) {
        if (whatsappInput) whatsappInput.classList.add('wd-error');
        showError(errorEl, config.errorPhoneText || 'Invalid phone');
        return;
      }
      // Clean and validate phone format (+XXXXXXXXXXXX)
      var cleanPhone = whatsapp.replace(/[\s\-\(\)]/g, '');
      if (!/^\+\d{7,15}$/.test(cleanPhone)) {
        if (whatsappInput) whatsappInput.classList.add('wd-error');
        showError(errorEl, config.errorPhoneText || 'Invalid phone');
        return;
      }
      whatsapp = cleanPhone;
    }

    // Validate privacy
    if (!privacy) {
      showError(errorEl, config.errorPrivacyText || 'Accept privacy policy');
      return;
    }

    // Token antibot. Si blocca qui solo se il widget e' vivo ma non ha ancora
    // risolto: in quel caso un attimo di pazienza basta, ed e' meglio di un 403
    // opaco dal server. Se invece il widget ha fallito del tutto (dominio non
    // autorizzato, Cloudflare irraggiungibile) non si punisce il cliente per un
    // guasto di configurazione: la richiesta parte e decide il server, che a sua
    // volta salta la verifica finche' il segreto non e' configurato.
    var token = turnstileToken();
    if (turnstileSitekey() && !token && !turnstileLastError) {
      showError(errorEl, config.errorText || 'Please try again');
      return;
    }

    // Show loading state
    if (submitBtn) submitBtn.disabled = true;
    if (submitText) submitText.style.display = 'none';
    if (submitLoading) submitLoading.style.display = '';

    // API call
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        whatsapp: (channel === 'whatsapp') ? whatsapp : null,
        channel: channel,
        tier: 10,
        lang: (document.documentElement.lang || navigator.language || 'en').substring(0, 2).toLowerCase(),
        'cf-turnstile-response': token
      })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error(data.error || config.errorText || 'Error');
        });
      }
      return response.json();
    })
    .then(function(data) {
      // Success — show success state
      markAsClaimed();

      var formState    = popup.querySelector('[data-wd-form-state]');
      var successState = popup.querySelector('[data-wd-success-state]');
      var successText  = popup.querySelector('[data-wd-success-text]');

      if (formState)    formState.style.display    = 'none';
      if (successState) successState.style.display = '';

      if (successText) {
        successText.textContent = (channel === 'whatsapp')
          ? (config.successWhatsappText || '')
          : (config.successEmailText || '');
      }

      // Mostra il codice sconto a schermo (robusto anche se l'email/WhatsApp è fallita)
      var codeBlock = popup.querySelector('[data-wd-code-block]');
      var codeValue = popup.querySelector('[data-wd-code]');
      if (data && data.discountCode && codeValue && codeBlock) {
        codeValue.textContent = data.discountCode;
        codeBlock.style.display = '';
      }
    })
    .catch(function(error) {
      // Il token Turnstile e' monouso: senza reset un secondo tentativo
      // fallirebbe la verifica anche se l'utente e' legittimo.
      resetTurnstile();
      showError(errorEl, error.message || config.errorText || 'Error');
    })
    .finally(function() {
      // Reset loading state
      if (submitBtn) submitBtn.disabled = false;
      if (submitText) submitText.style.display = '';
      if (submitLoading) submitLoading.style.display = 'none';
    });
  });

  function showError(errorEl, message) {
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = '';
    }
  }

  // Copia il codice sconto negli appunti dallo stato di successo
  document.addEventListener('click', function(ev) {
    var btn = ev.target.closest('[data-wd-copy]');
    if (!btn) return;
    var p = getPopup();
    var codeEl = p && p.querySelector('[data-wd-code]');
    var code = codeEl ? codeEl.textContent.trim() : '';
    if (!code) return;
    var markCopied = function() {
      var copied = btn.getAttribute('data-copied-text') || 'Copied!';
      var orig = btn.getAttribute('data-copy-text') || btn.textContent;
      btn.textContent = copied;
      btn.classList.add('is-copied');
      setTimeout(function() { btn.textContent = orig; btn.classList.remove('is-copied'); }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(function() { wdFallbackCopy(code); markCopied(); });
    } else {
      wdFallbackCopy(code);
      markCopied();
    }
  });

  function wdFallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {}
  }

})();

(function() {
  // EXT10 Exit-Intent Popup
  var ext10Shown = false;
  var EXT10_STORAGE_KEY = 'ext10_popup_shown';

  function getExt10Popup() {
    return document.querySelector('[data-ext10-popup]');
  }

  function showExt10Popup() {
    var popup = getExt10Popup();
    if (!popup || ext10Shown) return;
    try {
      if (sessionStorage.getItem(EXT10_STORAGE_KEY) === '1') return;
    } catch (e) {}
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ext10-popup-open');
    ext10Shown = true;
    try { sessionStorage.setItem(EXT10_STORAGE_KEY, '1'); } catch (e) {}
  }

  function hideExt10Popup() {
    var popup = getExt10Popup();
    if (!popup) return;
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ext10-popup-open');
  }

  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-ext10-close]') || e.target.closest('[data-ext10-close]')) {
      hideExt10Popup();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var popup = getExt10Popup();
      if (popup && popup.classList.contains('is-visible')) hideExt10Popup();
    }
  });

  document.addEventListener('mouseout', function(e) {
    if (!getExt10Popup()) return;
    if (ext10Shown) return;
    if (e.clientY > 10) return;
    var rel = e.relatedTarget;
    if (rel && document.body.contains(rel)) return;
    showExt10Popup();
  });

})();
